export default "__VITE_ASSET__DUJOQtm$__"